import { ADMIN_SWITCHER_ROLES } from "@/data/dojoOsOrgModel.js";

const R0_ROLE_TO_UI = {
  HANSHI: "hanshi",
  ADMIN: "hanshi",
  SENSEI: "sensei",
  SEMPAI: "assistant",
  ASSISTANT: "assistant",
  PARENT: "parent",
  STUDENT: "student",
  MEMBER: "student",
};

/**
 * @param {Array<{ role: string }>} [assignments]
 * @returns {string[]}
 */
export function mapR0RolesToUiIds(assignments = []) {
  const ids = new Set();
  for (const a of assignments) {
    const ui = R0_ROLE_TO_UI[String(a.role || "").toUpperCase()];
    if (ui) ids.add(ui);
  }
  return [...ids];
}

/**
 * @param {string[]} uiRoleIds
 * @param {'fr'|'en'} locale
 */
export function resolveSwitcherRoles(uiRoleIds, locale = "fr") {
  const allowed = new Set(uiRoleIds);
  return ADMIN_SWITCHER_ROLES.filter((r) => allowed.has(r.id)).map((r) => ({
    ...r,
    label: locale === "en" ? r.labelEn : r.labelFr,
  }));
}

/**
 * @param {string} uiRoleId
 * @param {string[]} allowedUiRoleIds
 */
export function isAllowedUiRole(uiRoleId, allowedUiRoleIds) {
  return allowedUiRoleIds.includes(uiRoleId);
}
